const config = {
 API_KEY: '73bfcf5e-5e98-42a7-a7f8-719492c65473',
};

export default config;
